import { render } from "./ResearcherBanner.vue?vue&type=template&id=37acb3b8&scoped=true"
import script from "./ResearcherBanner.vue?vue&type=script&lang=js"
export * from "./ResearcherBanner.vue?vue&type=script&lang=js"

import "./ResearcherBanner.vue?vue&type=style&index=0&id=37acb3b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37acb3b8"]])

export default __exports__